const axios = require('axios');
const { logAPIError } = require('../../../utils/logger');

const deserializeBrief = (data) => ({
    logo_name: {
        brand_name: data.logoName.brandName,
        slogan: data.logoName.slogan
    },
    logo_style: data.logoStyle,
    industries: data.industries,
    description: data.description,
    brand_values: data.brandValues
});

/**
 * Returns a brief by a given brief id from redis cache service
 * @returns {Promise<{ briefData: Object }>}
 */
const getBrief = async(id, config) => {
    const requestUrl = `${config.logo_maker_algo_kimera.url}/briefs/${id}`;
    try {
        const { data: { data } } = await axios.get(requestUrl);
        return { briefData: deserializeBrief(data) };
    } catch (e) {
        if (e.response.status !== 404) {
            logAPIError(e, { requestUrl, method: 'GET', briefId: id, message: 'Failed to fetch brief from algo kimera' });
        }
        return { briefData: {} };
    }
};

module.exports = getBrief;
